<template>
  <g clip-path="url(#clip0_718:43357)">
    <path d="M3.16797 0H17.3203V20H3.16797V0Z" fill="white" />
    <path
      d="M-3.90625 0H3.16797V20H-3.90625V0ZM17.3203 0H24.3945V20H17.3203V0ZM5.28516 9.66406L4.73828 9.85156L7.29297 12.0977C7.48828 12.6758 7.22656 12.8438 7.05859 13.1484L9.83203 12.7969L9.76172 15.5898L10.3398 15.5703L10.2109 12.8008L12.9922 13.1289C12.8203 12.7656 12.668 12.5742 12.8242 11.9961L15.3789 9.86719L14.9336 9.70703C14.5664 9.42188 15.0898 8.34766 15.168 7.66797C15.168 7.66797 13.6797 8.17969 13.582 7.91016L13.1953 7.1875L11.8438 8.67188C11.6953 8.71094 11.6328 8.64844 11.5977 8.52344L12.2227 5.41016L11.2305 5.96875C11.1484 6.00391 11.0664 5.96875 11.0117 5.875L10.0547 3.96094L9.07031 5.94922C8.99609 6.01953 8.92188 6.02734 8.85938 5.98047L7.91406 5.44922L8.48047 8.54297C8.4375 8.66016 8.32812 8.69922 8.20312 8.63281L6.90234 7.15625C6.73438 7.42969 6.61719 7.875 6.39453 7.97656C6.17188 8.06641 5.41797 7.78516 4.91406 7.67578C5.08594 8.29688 5.625 9.32812 5.28516 9.66797V9.66406Z"
      fill="#FF0000"
    />
  </g>
  <defs>
    <clipPath id="clip0_718:43357">
      <rect width="20" height="20" rx="10" fill="white" />
    </clipPath>
  </defs>
</template>
